import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@aigntx/ui";

const KEY = "aigntx-cookie-consent";

export function CookieConsent() {
  const { t } = useTranslation();
  const [done, setDone] = useState<boolean>(() => {
    try {
      return localStorage.getItem(KEY) === "1";
    } catch {
      return false;
    }
  });

  if (done) return null;

  function accept() {
    try {
      localStorage.setItem(KEY, "1");
    } catch {
      /* ignore */
    }
    setDone(true);
  }

  return (
    <div className="cookie" role="dialog" aria-label={t("cookie.title")}>
      <div className="cookie__text">
        {t("cookie.text")}{" "}
        <Link to="/privacy">{t("legal.privacy")}</Link>
      </div>
      <div className="cookie__actions">
        <Button size="sm" onClick={accept}>
          {t("cookie.accept")}
        </Button>
      </div>
    </div>
  );
}
